export const createEmployeeFields = [
  // {
  //   name: "role",
  //   label: "Role",
  //   type: "select",
  //   required: true,
  //   colSpan: {
  //     base: 6,
  //     sm: 6,

  //     md: 3,
  //     lg: 1,
  //   },
  //   options: [
  //     { value: "admin", label: "Admin" },
  //     { value: "doctor", label: "Doctor" },
  //     { value: "pharmacy", label: "Pharmacy" },
  //     { value: "patient", label: "Patient" },
  //     { value: "labDiagnostic", label: "Lab Diagnostic" },
  //   ],
  // },
  {
    name: "title",
    label: "Title",
    type: "select",
    required: true,
    placeholder: "Eg. Mr",
    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
    options: [
      { value: "mr", label: "Mr." },
      { value: "mrs", label: "Mrs." },
      { value: "ms", label: "Ms." },
      { value: "miss", label: "Miss" },
      { value: "dr", label: "Dr." },
    ],
  },
  {
    name: "name",
    label: "Full Name",
    type: "text",
    required: true,
        placeholder: "Eg. Abhishek kumar",

    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },
  {
    name: "mobile",
    label: "Mobile Number",
    type: "mobile",
    required: true,
        placeholder: "Eg. 9988775588",

    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },
  {
    name: "email",
    label: "Email",
    type: "email",
        placeholder: "Eg. abc@gmail.com",

    colSpan: {
      base: 6,
      sm: 6,
      md: 3,
      lg: 1,
    },
  },
  {
    name: "gender",
    label: "Gender",
    type: "select",
    required: true,
    colSpan: {
      base: 6,
      sm: 6,

      md: 3,
      lg: 1,
    },
    options: [
      { value: "male", label: "Male" },
      { value: "female", label: "Female" },
      { value: "other", label: "Other" },
    ],
  },

  {
    name: "dob",
    label: "Date of Birth",
    type: "date",
    colSpan: {
      base: 6,
      sm: 6,
      md: 6,
      lg: 1,
    },
  },

  {
    name: "address",
    label: "Address",
    type: "textarea",
    colSpan: 6,
  },
];

